import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './../../shared/services/language/language.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  selected;

  selectedLanguageSubscriber;
  selectedLanguage = '';
  showContent = false

  @Input() parentData;

  constructor(private translate: TranslateService,private languageservice:LanguageService) {
    this.selected = 'option2';
    this.selectedLanguageSubscriber = languageservice.translateLanguge.subscribe((value) => {
      this.selectedLanguage = value ? value : localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'nl';
      this.translate.use(this.selectedLanguage);
     });
   }

  ngOnInit(): void {
    console.log(this.parentData)
    this.showContent = this.parentData;
  }


}
